class BstReviewSlider {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-bst-review]')];
    this.dots = root.querySelector('[data-bst-review-dots]');
    this.index = 0;
    if (this.slides.length < 2) return;
    this.buildDots();
    root.querySelector('[data-bst-review-previous]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-bst-review-next]')?.addEventListener('click', () => this.show(this.index + 1));
  }

  buildDots() {
    this.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = index === 0 ? 'is-active' : '';
      this.dots.appendChild(dot);
    });
  }

  show(nextIndex) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === this.index));
    [...this.dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bst-review-slider]').forEach((root) => new BstReviewSlider(root));
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-bst-review-slider]').forEach((root) => new BstReviewSlider(root));
});
